import authService from './services/auth/auth.service'

function lazyLoad(view) {
  return () => import(`./views/${view}.vue`);
}
  
const routes = [
  {
    path: '/',
    component: lazyLoad("dashboard/Master"),
    beforeEnter: authService.isAuthGuard,
    children: [
      {
        path: '',
        name: 'jobs',
        component: lazyLoad("dashboard/jobs/jobOverview"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/monthly',
        name: 'monthly',
        component: lazyLoad("dashboard/monthly/monthlyOverview"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/jobs/create',
        name: 'createJob',
        component: lazyLoad("dashboard/jobs/crud"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/jobs/edit/:index',
        name: 'editJob',
        component: lazyLoad("dashboard/jobs/crud"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/jobs/:index',
        name: 'jobDetail',
        component: lazyLoad("dashboard/jobs/detail"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/users',
        name: 'usersOverview',
        component: lazyLoad("dashboard/users/userOverview"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/users/create',
        name: 'createUser',
        component: lazyLoad("dashboard/users/crud"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/users/:index',
        name: 'userDetail',
        component: lazyLoad("dashboard/users/detail"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/studios',
        name: 'studioOverview',
        component: lazyLoad("dashboard/studio/studioOverview"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/studios/create',
        name: 'createStudio',
        component: lazyLoad("dashboard/studio/crud"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/studios/edit/:index',
        name: 'editStudio',
        component: lazyLoad("dashboard/studio/crud"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/studios/:index',
        name: 'studioDetail',
        component: lazyLoad("dashboard/studio/detail"),
        beforeEnter: authService.isAuthGuard,
      },
      {
        path: '/settings',
        name: 'settings',
        component: lazyLoad("dashboard/Settings"),
        beforeEnter: authService.isAuthGuard,
      },
    ],
  },
  {
    path: '/join',
    component: lazyLoad("auth/Auth"),
    children: [
      {
        path: '',
        redirect: { name: 'login' },
      },
      {
        path: 'register',
        name: 'register',
        component: lazyLoad("auth/Register"),
        beforeEnter: authService.isNotAuthGuard,
      },
      {
        path: 'login',
        name: 'login',
        component: lazyLoad("auth/Login"),
        beforeEnter: authService.isNotAuthGuard,
      },
      {
        path: 'reset/:resetToken',
        name: 'reset',
        component: lazyLoad("auth/ResetPassword"),
      },
      {
        path: 'request',
        name: 'requestPassword',
        component: lazyLoad("auth/RequestPassword"),
      },
      {
        path: 'invitation/:token',
        name: 'invitation',
        component: lazyLoad("auth/invitation"),
        beforeEnter: authService.isNotAuthGuard,
      },
    ],
  },
];

  export default routes;